import React from "react";
import { Typography, CardContent, Stack, Box, Avatar } from "@mui/material";
// import CreateButton from '../styled-components/buttons'
import { useNavigate } from "react-router-dom";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import QueueIcon from "@mui/icons-material/Queue";



function CreateWorkRequest() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/departmentworkrequest/register");
  };
  return (
    <>
      <StyledCard sx={{ cursor: "pointer",  bgcolor: "primary.light" }}>
        <CardContent onClick={handleClick}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            mb={1}
          >
            <Box>
              <Typography mb={1} variant="subtitle1"color={"common.white"} >
                Create New Work Request (WR)
              </Typography>
              <Typography m={0} variant="h1" color={"common.white"} >

              </Typography>
            </Box>
            <Box p={1} >
              <QueueIcon sx={{ fontSize: 30, color: "common.white" }} />
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default CreateWorkRequest;
